export default {
  "auth.login": "ログイン",
  "auth.register": "新規登録",
  "auth.email": "メールアドレス",
  "auth.password": "パスワード",
  "auth.logout": "ログアウト",
  "auth.loginFailed": "ログインに失敗しました",
  "auth.registerFailed": "ユーザー登録に失敗しました",
  "nav.dashboard": "評価ダッシュボード",
  "nav.activeEvaluations": "進行中の評価",
  "nav.completedEvaluations": "完了した評価",
  "nav.createNew": "新しい評価を作成",
  "nav.projectMerge": "プロジェクト統合",
  "nav.share": "共有設定",
  "nav.copy": "コピー",
  "nav.delete": "削除",
  "nav.settings": "設定",
  "menu.language": "言語設定",
  "menu.colorPalette": "カラーパレット",
  "status.inProgress": "進行中",
  "status.completed": "完了",
  "status.untitled": "無題の評価",
  "stats.subjects": "評価対象",
  "stats.criteria": "観点",
  "stats.progress": "進捗",
  "step.criteriaExtraction": "評価観点の抽出",
  "step.comparison": "初期評価",
  "step.subjectRegistration": "評価対象登録",
  "form.evaluationPolicy": "評価方針",
  "form.policyDescription": "評価の方針・重視したい点",
  "form.policyPlaceholder": "例：論理的な構成を重視する、創造性やオリジナリティを評価したい",
  "btn.aiExtraction": "AI観点抽出",
  "btn.manualAdd": "観点を手動追加",
  "btn.next": "次へ",
  "btn.back": "戻る",
  "plan.free": "フリープラン",
  "plan.professional": "プラン",
  "plan.business": "BUSINESS",
  "plan.school": "SCHOOL",
  "plan.unlimitedProjects": "無制限プロジェクト",
  "plan.prioritySupport": "優先サポート",
  "plan.dataExport": "データエクスポート",
  "plan.monthlyRenewal": "毎月自動更新",
  "plan.cancelAnytime": "いつでもキャンセル可能",
  "plan.paymentFailed": "決済の開始に失敗しました",
  "confirm.delete": "削除しますか？この操作は取り消せません",
  "alert.appUpdate": "アプリケーションの更新を検出しました",
  "alert.projectLimit": "評価プロジェクト作成数の上限に達しています",
  "common.loading": "読み込み中...",
  "common.save": "保存",
  "common.cancel": "キャンセル",
  "common.confirm": "確認",
  "common.error": "エラー",
  "common.success": "成功",
  "common.initializing": "アプリケーションを初期化中...",
  "common.connecting": "接続中...",
  "common.processing": "処理中...",
  "common.required": "必須",
  "common.close": "閉じる",
  "common.preview": "プレビュー",
  "common.edit": "編集",
  "common.details": "詳細",
  "common.position": "位置",
  "common.rank": "順位",
  "common.placed": "配置済み",
  "common.characters": "文字",
  "common.items": "件",
  "common.folders": "フォルダ",
  "common.folder": "フォルダ",
  "common.files": "ファイル",
  "common.openInNewTab": "新しいタブで開く",
  "common.next": "次へ",
  "common.prev": "前へ",
  "date.today": "今日",
  "date.yesterday": "昨日",
  "date.thisWeek": "今週",
  "date.lastWeek": "先週",
  "error.dashboardLoad": "ダッシュボード読み込みエラー",
  "error.serverUnavailable": "サーバーに接続できません。しばらくしてから再試行してください",
  "error.evaluationLimit": "評価制限の確認に失敗しました",
  "error.loadingData": "読み込みエラー",
  "error.copyFailed": "コピーエラー",
  "error.deleteFailed": "削除に失敗しました",
  "error.copyProcess": "コピー処理中にエラーが発生しました",
  "error.deleteProcess": "削除処理中にエラーが発生しました",
  "error.sharingUpdate": "共有設定の更新に失敗しました",
  "error.decryptionError": "復号化エラー",
  "msg.loadingDashboard": "ダッシュボードを読み込み中...",
  "msg.retry": "再試行",
  "msg.projectLimitReached": "評価プロジェクト作成数の上限に達しています",
  "msg.upgradeToProPlan": "PROにアップグレードしてください",
  "msg.cannotCreateProject": "評価プロジェクトを作成できません",
  "msg.freeLastProject": "フリープランでは評価プロジェクトは1個まで作成できます。これが最後の作成可能枠です。",
  "msg.untitledProject": "無題の評価プロジェクト",
  "msg.welcome": "ようこそ",
  "msg.welcomeWithName": "ようこそ、{{name}}さん",
  "msg.created": "作成",
  "msg.updated": "更新",
  "msg.completed": "完了",
  "copy.title": "「{{title}}」のコピーを作成します。",
  "copy.newTitle": "新しいタイトルを入力してください（空欄の場合は「元のタイトル (コピー)」になります）",
  "progress.completed": "完了",
  "googleDrive.title": "Google Drive からインポート",
  "googleDrive.connect": "Google Drive に接続",
  "googleDrive.description": "評価対象をGoogle Driveから一括インポートするには、まずGoogleアカウントでサインインしてください。",
  "googleDrive.signIn": "Googleアカウントでサインイン",
  "googleDrive.myDrive": "マイドライブ",
  "googleDrive.emptyFolder": "このフォルダは空です",
  "googleDrive.filesSelected": "件のファイルを選択中",
  "googleDrive.importSelected": "選択したファイルをインポート",
  "googleDrive.searchPlaceholder": "ファイル名で検索...",
  "googleDrive.searchResults": "検索結果",
  "googleDrive.noSearchResults": "検索に一致するファイルが見つかりませんでした",
  "googleDrive.allTypes": "すべてのファイル",
  "googleDrive.documents": "ドキュメント",
  "googleDrive.spreadsheets": "スプレッドシート",
  "googleDrive.presentations": "プレゼンテーション",
  "googleDrive.sortByName": "名前順",
  "googleDrive.sortByModified": "更新日順",
  "googleDrive.selectAll": "すべて選択",
  "googleDrive.clearSelection": "選択をクリア",
  "modal.closeModal": "モーダルを閉じる",
  "dashboard.projectLimitReached": "評価プロジェクト作成数の上限（{{count}}個）に達しています。PROにアップグレードしてください。",
  "dashboard.cannotCreateProject": "評価プロジェクトを作成できません。",
  "dashboard.freeLastProject": "フリープランでは評価プロジェクトは1個まで作成できます。これが最後の作成可能枠です。",
  "dashboard.evaluationLimitCheckFailed": "評価制限の確認に失敗しました。",
  "dashboard.loadingError": "読み込みエラー: {{message}}",
  "dashboard.copyError": "コピーエラー: {{message}}",
  "dashboard.copyProcessError": "コピー処理中にエラーが発生しました",
  "dashboard.deleteError": "削除エラー: {{message}}",
  "dashboard.deleteProcessError": "削除処理中にエラーが発生しました",
  "dashboard.shareSettingsUpdateFailed": "共有設定の更新に失敗しました",
  "dashboard.copyProjectTitle": "「{{title}}」のコピーを作成します。",
  "dashboard.copyProjectPrompt": "新しいタイトルを入力してください（空欄の場合は「元のタイトル (コピー)」になります）:",
  "dashboard.deleteConfirm": "「{{title}}」を削除しますか？この操作は取り消せません。",
  "dashboard.statusUnknown": "不明",
  "dashboard.collaborators": "{{count}}人の共同作業者",
  "dashboard.menu": "メニュー",
  "dashboard.shareSettings": "共有設定",
  "dashboard.copy": "コピー",
  "dashboard.delete": "削除",
  "dashboard.subjects": "評価対象",
  "dashboard.criteria": "観点",
  "dashboard.progress": "進捗",
  "dashboard.completed": "完了",
  "dashboard.created": "作成:",
  "dashboard.updated": "更新:",
  "dashboard.loadingDashboard": "ダッシュボードを読み込み中...",
  "dashboard.retry": "再試行",
  "dashboard.title": "評価ダッシュボード",
  "dashboard.projectMerge": "プロジェクト統合",
  "dashboard.createNew": "新しい評価を作成",
  "dashboard.inProgressTab": "進行中の評価",
  "dashboard.completedTab": "完了した評価",
  "dashboard.noInProgress": "進行中の評価がありません",
  "dashboard.noInProgressDesc": "新しい評価を作成して始めましょう。",
  "dashboard.noCompleted": "完了した評価がありません",
  "dashboard.noCompletedDesc": "評価を完了すると、ここに表示されます。",
  "dashboard.untitledProject": "無題の評価プロジェクト",
  "dashboard.enterProjectName": "プロジェクト名を入力してください",
  "dashboard.sharing": "共有中",
  "billing.paymentCompleted": "決済完了",
  "billing.subscriptionCompleted": "サブスクリプションの登録が完了しました。ご利用いただきありがとうございます！",
  "billing.paymentCanceled": "決済がキャンセルされました。再度お試しいただくか、お問い合わせください。",
  "settings.backToDashboard": "← ダッシュボードに戻る",
  "userSettings.title": "ユーザー設定",
  "userSettings.description": "アカウント情報とセキュリティ設定を管理します。",
  "userSettings.basicInfo": "基本情報",
  "userSettings.username": "ユーザー名",
  "userSettings.usernamePlaceholder": "ユーザー名を入力",
  "userSettings.email": "メールアドレス",
  "userSettings.emailPlaceholder": "example@domain.com",
  "userSettings.displayName": "表示名",
  "userSettings.displayNamePlaceholder": "表示名を入力（任意）",
  "userSettings.displayNameHelp": "他のユーザーに表示される名前です。",
  "userSettings.saving": "保存中...",
  "userSettings.saveSettings": "設定を保存",
  "userSettings.securitySettings": "セキュリティ設定",
  "userSettings.securityMode": "セキュリティモード",
  "userSettings.securityModeDescription": "データの暗号化を有効にして、プライバシーを保護します。",
  "userSettings.securityOn": "有効",
  "userSettings.securityOff": "無効",
  "userSettings.securityCode": "セキュリティコード",
  "userSettings.hide": "非表示",
  "userSettings.show": "表示",
  "userSettings.encryptionCode": "暗号化コード",
  "userSettings.recoveryCode": "復旧コード",
  "userSettings.copy": "コピー",
  "userSettings.generateNewKeys": "新しいキーを生成",
  "userSettings.manualKeyInput": "手動でキーを入力",
  "userSettings.viewSharedData": "共有データの閲覧",
  "userSettings.viewSharedDataDescription": "他のユーザーから共有された暗号化データを閲覧するためのキーを入力できます。",
  "userSettings.inputEncryptionKey": "暗号化キーを入力",
  "userSettings.manualKeyTitle": "暗号化キーの手動入力",
  "userSettings.manualKeyDescription": "共有された暗号化キーのペアを入力してください。",
  "userSettings.publicKey": "公開キー",
  "userSettings.publicKeyPlaceholder": "公開キーを入力してください",
  "userSettings.privateKey": "秘密キー",
  "userSettings.privateKeyPlaceholder": "秘密キーを入力してください",
  "userSettings.keyWarning": "注意：",
  "userSettings.keyWarningText": "これらのキーは機密情報です。安全な場所に保管してください。",
  "userSettings.setKeys": "キーを設定",
  "userSettings.requiredFieldsError": "ユーザー名とメールアドレスは必須項目です。",
  "userSettings.enableSecurityModeConfirm": "セキュリティモードを有効にしますか？データの暗号化が開始されます。",
  "userSettings.securityModeEnabled": "セキュリティモードが有効になりました。",
  "userSettings.securityModeDisabled": "セキュリティモードが無効になりました。",
  "userSettings.generateNewKeysConfirm": "新しいキーを生成しますか？既存のキーは無効になります。",
  "userSettings.newKeysGenerated": "新しいキーが生成されました。",
  "userSettings.bothKeysRequired": "公開キーと秘密キーの両方が必要です。",
  "userSettings.invalidPublicKeyFormat": "公開キーの形式が正しくありません。",
  "userSettings.invalidPrivateKeyFormat": "秘密キーの形式が正しくありません。",
  "userSettings.keysSet": "キーが設定されました。",
  "userSettings.keySetError": "キーの設定中にエラーが発生しました。",
  "userSettings.copiedToClipboard": "クリップボードにコピーしました。",
  "userSettings.copyFailed": "コピーに失敗しました。",
  "billing.currentPlan": "現在のプラン",
  "billing.status.developerAccess": "開発者アクセス",
  "billing.status.active": "利用中",
  "billing.status.free": "フリー",
  "billing.nextRenewalDate": "次回自動更新日",
  "billing.autoRenewalNote": "（自動で課金されます）",
  "billing.expiresAt": "有効期限",
  "billing.cancelNotice": "このサブスクリプションは期間終了時にキャンセルされます。",
  "billing.cancelSubscription": "サブスクリプションをキャンセル",
  "billing.cancelSubscriptionConfirm": "サブスクリプションをキャンセルしますか？現在の期間終了時にキャンセルされます。",
  "billing.cancelSubscriptionSuccess": "サブスクリプションのキャンセルを受け付けました。現在の期間終了時にキャンセルされます。",
  "billing.cancelSubscriptionFailed": "キャンセルに失敗しました。",
  "billing.forIndividual": "（個人向け）",
  "billing.forBusiness": "（企業向け）",
  "billing.forSchool": "（学校向け）",
  "billing.free": "無料",
  "billing.month": "月",
  "billing.year": "年",
  "billing.features": "機能",
  "billing.upgrade": "アップグレード",
  "billing.customQuote": "個別見積",
  "billing.flexibleCustomization": "柔軟なカスタマイズ対応",
  "billing.educationalDiscount": "教育機関特別価格",
  "billing.requestCorporateQuote": "企業向け見積依頼",
  "billing.requestAcademicQuote": "学校向け見積依頼",
  "billing.aboutBilling": "課金について",
  "billing.autoRenewal": "自動更新",
  "billing.autoRenewalDescription": "月額プランは毎月同じ日に自動的に更新されます",
  "billing.nextRenewalDateDescription": "ご利用中のお客様は上記「現在のプラン」で確認できます",
  "billing.cancellation": "キャンセル",
  "billing.cancellationDescription": "いつでもキャンセル可能で、現在の期間終了時にサービス停止となります",
  "billing.payment": "決済",
  "billing.paymentDescription": "Stripeによる安全な決済システムを使用しています",
  "billing.receipt": "領収書",
  "billing.receiptDescription": "決済完了後、自動でメールに送信されます",
  "billing.aiUsageLimitation": "＊ほかのユーザーの利用状況により制限がかかる可能性があります",
  "billing.enterprise": "企業向け",
  "billing.education": "教育機関向け",
  "billing.feature.limited_projects": "評価プロジェクト: 最大1個",
  "billing.feature.unlimited_projects": "評価プロジェクト: 無制限",
  "billing.feature.unlimited_collaborators": "コラボレーター: 無制限",
  "billing.feature.basic_rubric": "ルーブリック機能",
  "billing.feature.advanced_rubric": "ルーブリック機能（全機能）",
  "billing.feature.ai_assistance": "AI支援機能（開発中）",
  "billing.feature.priority_support": "メールサポート",
  "billing.feature.data_export": "CSVエクスポート（50回/日）",
  "billing.feature.custom_templates": "カスタムテンプレート（開発中）",
  "billing.feature.pdf_export": "PDF出力（無制限）",
  "billing.feature.limited_pdf_export": "PDF出力（5回/日まで）",
  "billing.feature.no_csv_export": "CSVエクスポート: 利用不可",
  "billing.feature.sharing_reception": "共有招待の受信",
  "billing.feature.allProfessionalFeatures": "プロフェッショナルプランの全機能",
  "billing.feature.unlimitedUsers": "無制限のユーザー数",
  "billing.feature.dedicatedSupportAgent": "専用サポート担当者",
  "billing.feature.customIntegrationAPI": "カスタム統合・API開発",
  "billing.feature.customBranding": "独自ブランディング対応",
  "billing.feature.singleSignOn": "シングルサインオン（SSO）",
  "billing.feature.auditLogSecurity": "監査ログ・セキュリティ機能",
  "billing.feature.onPremiseDeployment": "オンプレミス導入対応",
  "billing.feature.trainingImplementationSupport": "研修・導入支援",
  "billing.feature.unlimitedStudentFacultyAccounts": "無制限の学生・教職員アカウント",
  "billing.feature.educationalInstitutionSpecialPricing": "教育機関向け特別価格",
  "billing.feature.classroomPracticalTemplates": "授業・実習向けテンプレート",
  "billing.feature.gradeManagementSystemIntegration": "成績管理システム連携",
  "billing.feature.learningAnalyticsReporting": "学習分析・レポート機能",
  "billing.feature.parentGuardianSharingFeature": "親・保護者向け共有機能",
  "billing.feature.educationalInstitutionDedicatedSupport": "教育機関専用サポート",
  "billing.feature.implementationTrainingTeacherTraining": "導入研修・教員トレーニング",
  "quote.title": "エンタープライズプラン見積もり依頼",
  "quote.submit": "見積もりを依頼する",
  "quote.sections.contactInfo": "ご担当者様情報",
  "quote.sections.usagePlan": "ご利用計画",
  "quote.sections.budgetRequirements": "ご予算・要件",
  "quote.fields.name": "お名前",
  "quote.fields.position": "役職",
  "quote.fields.phone": "電話番号",
  "quote.fields.expectedUsers": "想定利用者数",
  "quote.fields.timeline": "導入希望時期",
  "quote.fields.useCase": "利用目的・用途",
  "quote.fields.currentSolution": "現在の評価方法・ツール",
  "quote.fields.budget": "ご予算感",
  "quote.fields.requirements": "必要な機能・要件",
  "quote.fields.message": "その他ご要望・ご質問",
  "quote.placeholders.currentSolution": "現在使用している評価方法やツールがあれば教えてください",
  "quote.placeholders.message": "その他ご要望やご質問がございましたらお聞かせください",
  "quote.timeline.immediate": "すぐに",
  "quote.timeline.oneMonth": "1ヶ月以内",
  "quote.timeline.threeMonths": "3ヶ月以内",
  "quote.timeline.sixMonths": "6ヶ月以内",
  "quote.timeline.oneYear": "1年以内",
  "quote.timeline.undecided": "未定",
  "quote.success.title": "見積もり依頼を受け付けました",
  "quote.error.submitFailed": "見積もり依頼の送信に失敗しました",
  "quote.error.submitFailedRetry": "見積もり依頼の送信に失敗しました。しばらく経ってから再度お試しください。",
  "common.pleaseSelect": "選択してください",
  "common.other": "その他",
  "common.submitting": "送信中...",
  "quote.corporate.subtitle": "企業向け",
  "quote.corporate.description": "貴社のニーズに合わせたカスタマイズ可能なエンタープライズソリューションをご提案いたします。以下のフォームにご記入いただき、お気軽にお問い合わせください。",
  "quote.corporate.sections.companyInfo": "会社情報",
  "quote.corporate.fields.companyName": "会社名",
  "quote.corporate.fields.department": "部署名",
  "quote.corporate.userCounts.small": "10〜50名",
  "quote.corporate.userCounts.medium": "51〜100名",
  "quote.corporate.userCounts.large": "101〜300名",
  "quote.corporate.userCounts.xlarge": "301〜500名",
  "quote.corporate.userCounts.xxlarge": "501〜1,000名",
  "quote.corporate.userCounts.enterprise": "1,000名以上",
  "quote.corporate.budget.under500k": "月額50万円未満",
  "quote.corporate.budget.500k1m": "月額50〜100万円",
  "quote.corporate.budget.1m3m": "月額100〜300万円",
  "quote.corporate.budget.3m5m": "月額300〜500万円",
  "quote.corporate.budget.over5m": "月額500万円以上",
  "quote.corporate.placeholders.useCase": "例：社内評価システム、採用面接評価、研修効果測定など",
  "quote.corporate.formNote": "送信いただいた情報は、プライバシーポリシーに従って適切に管理されます。",
  "quote.success.corporate.message": "ご依頼いただきありがとうございます。担当者より2営業日以内にご連絡差し上げます。",
  "quote.corporate.requirements.sso": "シングルサインオン（SSO）",
  "quote.corporate.requirements.activeDirectory": "Active Directory連携",
  "quote.corporate.requirements.customBranding": "カスタムブランディング",
  "quote.corporate.requirements.dedicatedServer": "専用サーバー・オンプレミス導入",
  "quote.corporate.requirements.apiIntegration": "API連携・カスタム統合",
  "quote.corporate.requirements.auditLogs": "監査ログ・セキュリティ機能",
  "quote.corporate.requirements.multilingual": "多言語対応",
  "quote.corporate.requirements.support24": "24時間サポート",
  "quote.corporate.requirements.training": "導入トレーニング・研修",
  "quote.corporate.requirements.dataMigration": "データ移行支援",
  "quote.academic.subtitle": "学校・教育機関向け",
  "quote.academic.description": "教育機関のニーズに特化したソリューションをご提案いたします。特別価格でのご提供や教育現場に最適な機能カスタマイズも承ります。",
  "quote.academic.sections.institutionInfo": "教育機関情報",
  "quote.academic.fields.institutionName": "学校・機関名",
  "quote.academic.fields.institutionType": "機関種別",
  "quote.academic.fields.department": "学部・学科・部署",
  "quote.academic.fields.positionTitle": "役職・職種",
  "quote.academic.fields.expectedUsers": "想定利用者数（教職員）",
  "quote.academic.fields.studentCount": "学生数",
  "quote.academic.fields.currentSolution": "現在の評価方法・システム",
  "quote.academic.fields.budgetAnnual": "ご予算感（年額）",
  "quote.academic.institutionTypes.university": "大学",
  "quote.academic.institutionTypes.college": "短期大学・専門学校",
  "quote.academic.institutionTypes.highSchool": "高等学校",
  "quote.academic.institutionTypes.juniorHigh": "中学校",
  "quote.academic.institutionTypes.elementary": "小学校",
  "quote.academic.institutionTypes.vocational": "職業訓練校",
  "quote.academic.userCounts.small": "5〜20名",
  "quote.academic.userCounts.medium": "21〜50名",
  "quote.academic.userCounts.large": "51〜100名",
  "quote.academic.userCounts.xlarge": "101〜300名",
  "quote.academic.userCounts.xxlarge": "301〜500名",
  "quote.academic.userCounts.enterprise": "500名以上",
  "quote.academic.studentCounts.under100": "100名未満",
  "quote.academic.studentCounts.small": "100〜500名",
  "quote.academic.studentCounts.medium": "501〜1,000名",
  "quote.academic.studentCounts.large": "1,001〜3,000名",
  "quote.academic.studentCounts.xlarge": "3,001〜10,000名",
  "quote.academic.studentCounts.xxlarge": "10,000名以上",
  "quote.academic.timeline.nextSemester": "次学期",
  "quote.academic.timeline.nextYear": "次年度",
  "quote.academic.budget.under1m": "100万円未満",
  "quote.academic.budget.1m3m": "100〜300万円",
  "quote.academic.budget.3m5m": "300〜500万円",
  "quote.academic.budget.5m10m": "500〜1,000万円",
  "quote.academic.budget.over10m": "1,000万円以上",
  "quote.academic.placeholders.position": "例：教授、助教、事務職員など",
  "quote.academic.placeholders.useCase": "例：学生評価、実習・実技評価、教員研修、授業評価など",
  "quote.academic.placeholders.currentSolution": "現在使用している評価方法やシステムがあれば教えてください",
  "quote.academic.placeholders.message": "教育機関特有のご要望やご質問がございましたらお聞かせください",
  "quote.academic.formNote": "送信いただいた情報は、プライバシーポリシーに従って適切に管理されます。",
  "quote.success.academic.message": "ご依頼いただきありがとうございます。教育機関専門の担当者より2営業日以内にご連絡差し上げます。",
  "quote.academic.requirements.lmsIntegration": "学習管理システム（LMS）連携",
  "quote.academic.requirements.gradeManagement": "成績管理システム連携",
  "quote.academic.requirements.studentPortal": "学生ポータル連携",
  "quote.academic.requirements.parentSharing": "親・保護者向け共有機能",
  "quote.academic.requirements.courseTemplates": "授業・実習向けテンプレート",
  "quote.academic.requirements.learningAnalytics": "学習分析・レポート機能",
  "quote.academic.requirements.multilingualEng": "多言語対応（英語等）",
  "quote.academic.requirements.teacherTraining": "教員向けトレーニング",
  "quote.academic.requirements.implementationSupport": "導入サポート・研修",
  "common.backToDashboard": "ダッシュボードに戻る",
  "autoSave.unsaved": "未保存",
  "autoSave.savedSecondsAgo": "{{seconds}}秒前に保存",
  "autoSave.savedMinutesAgo": "{{minutes}}分前に保存",
  "autoSave.savedAtTime": "{{time}}に保存",
  "autoSave.saving": "保存中...",
  "autoSave.unsavedChanges": "未保存の変更あり",
  "autoSave.autoSaveOn": "自動保存: ON",
  "plan.pro": "PRO",

  // Report Generation
  "report.title": "成績表出力",
  "report.evaluationNotice": "評価通知表",
  "report.evaluationDate": "評価日",
  "report.criteriaEvaluation": "観点別評価",
  "report.overallEvaluation": "総合評価",
  "report.comments": "所見",
  "report.commentsPlaceholder": "詳細やコメントを入力...",
  "report.commentsEmpty": "詳細が入力されていません",
  "report.editComments": "詳細を編集",
  "report.showPreview": "プレビュー表示",
  "report.hidePreview": "プレビュー非表示",
  "report.preview": "プレビュー",
  "report.criterionColumn": "観点",
  "report.gradeColumn": "等級",
  "report.rankColumn": "順位",
  "report.descriptionColumn": "記述",
  "report.nthGrade": "{{grade}}等級",
  "report.topPercentile": "上位{{percent}}%",
  "report.rankFormat": "{{position}}/{{total}}",
  "report.noDescription": "-",
  "report.personalEvaluation": "個人評価",
  "report.groupAverage": "集団平均",
  "report.summary": "サマリー",
  "report.enableOverallEvaluation": "総合評価を有効化",
  "report.disableOverallEvaluation": "総合評価を無効化",
  "report.pointsFormat": "{{score}}点 / {{maxScore}}点",
  "report.percentageFormat": "({{percentage}}%)",
  "report.configureWeights": "配点設定",
  "report.footerNote": "※ この評価は基準準拠評価と相対評価を併記しています。",
  "report.rubricTitle": "評価基準（ルーブリック）",
  "report.noRubric": "ルーブリックが生成されていません",
  "report.noSubjects": "評価対象が登録されていません。",
  "report.print": "印刷",
  "report.downloadPdf": "PDFダウンロード",
  "report.downloadAllPdf": "全{{count}}件をPDFダウンロード",
  "report.allEvaluations": "全評価結果",
  "report.pdfGenerationFailed": "PDF生成に失敗しました",
  "report.pdfGenerationError": "PDF生成エラー: {{error}}",
  "report.pdfGeneration.generating": "PDF生成中",
  "report.pdfGeneration.generatingDescription": "PDFを生成しています...",
  "report.pdfGeneration.step1": "データを準備中",
  "report.pdfGeneration.step2": "PDFを生成中",
  "report.pdfGeneration.step3": "ダウンロード準備中",
  "report.noRubricDescriptions": "ルーブリックの記述がありません",
  "report.commentGenerationFailed": "コメント生成に失敗しました",
  // ProductTableView error messages
  "productTable.error.invalidInput": "有効な評価対象が入力されていません。",
  "productTable.error.encryptionFailed": "「{{title}}」の暗号化に失敗しました。",
  "productTable.success.addedItems": "{{count}}件の評価対象を追加しました。",
  "productTable.error.addingItems": "評価対象の追加中にエラーが発生しました。",
  // ProductDetailModal error messages
  "productDetail.error.encryptionFailed": "暗号化に失敗しました。セキュリティ設定を確認してください。",
  // ShareModal error messages
  "share.error.settingsFailed": "共有設定の変更に失敗しました",
  "share.success.linkGenerated": "招待リンクを生成しました",
  "share.error.linkGenerationFailed": "招待リンクの生成に失敗しました",
  "share.success.linkCopied": "招待リンクをクリップボードにコピーしました",
  "share.error.copyFailed": "コピーに失敗しました",
  "share.success.invitationSent": "招待を送信しました",
  "share.error.invitationFailed": "招待の送信に失敗しました",
  // CollaborationPanel error messages
  "collaboration.success.invitationSent": "招待を送信しました",
  "collaboration.error.invitationFailed": "招待の送信に失敗しました",
  "collaboration.success.collaboratorRemoved": "共同作業者を削除しました",
  "collaboration.error.removalFailed": "削除に失敗しました",
// ここですよ！
  "report.generatingPdf": "PDF生成中...",
  "report.generatingPdfDescription": "{{count}}件の評価レポートをPDFに変換しています",
  "report.pdfStep1": "レポートデータを準備中",
  "report.pdfStep2": "PDFを生成中",
  "report.pdfStep3": "ダウンロード準備中",
  "report.downloadPdfLimitReached": "PDFダウンロード (上限達成)",
  "report.pdfExportLimit": "PDF出力の上限（1日{{count}}枚）に達しました。{{planName}}にアップグレードするか、明日再試行してください。",
  "report.pdfExportError": "PDF出力ができません。",
  "report.reportCardNotFound": "成績表が見つかりません。",
  "report.pdfExportStatus": "本日のPDF出力: {{current}}/{{max}}",
  "report.pdfExportRemaining": " (残り{{remaining}}枚)",
  "report.pdfExportLimitReached": "本日の出力上限に達しました。{{planName}}で無制限出力が可能です。",
  "billing.businessPrice": "¥2,500〜",
  "billing.schoolPrice": "¥700〜",
  "billing.pricePerMonth": "/月・人",

  // Steps
  "steps.process.ariaLabel": "評価プロセス",
  "steps.productRegistration.title": "対象登録",
  "steps.criteriaExtraction.title": "規準設定",
  "steps.comparison.title": "初期評価",
  "steps.gradeAssignment.title": "評定設定",
  "steps.rubricGeneration.title": "言語化",
  "steps.quickEvaluation.title": "仕上げ",
  "steps.reportGeneration.title": "成績表",

  // Criteria Extraction
  "criteriaExtraction.emptyState.title": "評価対象を先に登録してください",
  "criteriaExtraction.emptyState.description": "観点を抽出するには、まず評価対象を登録する必要があります。",
  "criteriaExtraction.emptyState.backButton": "評価対象登録に戻る",
  "criteriaExtraction.title": "どこを評価しますか？",
  "criteriaExtraction.criteriaListTitle": "評価観点一覧",
  "criteriaExtraction.description": "評価の観点をAIが提案します。まずは評価したいポイントを教えてください",
  "criteriaExtraction.policyTitle": "評価の方針・重視したい点",
  "criteriaExtraction.policyDescription": "どのような観点で評価したいか、具体的に記述してください。AIが最適な評価観点を自動抽出します。",
  "criteriaExtraction.policyLabel": "評価方針",
  "criteriaExtraction.policyPlaceholder": "例：論理的な構成を重視する、創造性やオリジナリティを評価したい、実現可能性を重視する など",
  "criteriaExtraction.removePolicyTitle": "評価方針{{index}}を削除",
  "criteriaExtraction.addPolicyButton": "評価方針を追加",
  "criteriaExtraction.addCriteriaButton": "手動で観点を追加",
  "criteriaExtraction.extractButton": "AIで観点を抽出",
  "criteriaExtraction.productDescriptionPlaceholder": "評価したい点を簡単に入力してください（例：論理性、創造性、実現可能性など）",
  "criteriaExtraction.addButton": "ここをクリックして観点を追加",
  "criteriaExtraction.emptyHint": "クリックして最初の評価観点を設定しましょう！",
  "criteriaExtraction.modalTitle": "詳細な評価方針の入力",
  "criteriaExtraction.quickInputPlaceholder": "評価したいポイントを入力してください（例：論理性、創造性、実現可能性など）",
  "criteriaExtraction.quickInputHint": "複数の評価方針を詳しく入力したい場合は「詳細入力」ボタンをご利用ください",
  "criteriaExtraction.detailedInputButton": "詳細入力",
  "criteriaExtraction.extracting": "観点を抽出中",
  "criteriaExtraction.extractingDescription": "評価対象から最適な観点をAIが分析しています",
  "criteriaExtraction.extractingButton": "AI抽出中...",
  "criteriaExtraction.step1": "評価対象を分析中",
  "criteriaExtraction.step2": "観点を生成中",
  "criteriaExtraction.step3": "説明文を作成中",
  "criteriaExtraction.inputFormTitle": "評価方針の入力",
  "criteriaExtraction.inputFormSubtitle": "評価したいポイントを入力してください",
  "criteriaExtraction.productDescriptionsLabel": "評価対象の説明",
  "criteriaExtraction.extractedTitle": "抽出された評価観点",
  "criteriaExtraction.extractedSubtitle": "{{count}}個の評価観点が抽出されました。内容を確認・編集してください。",
  "criteriaExtraction.addCriterionButton": "観点を手動追加",
  "criteriaExtraction.addCriterionCard": "ここをクリックして観点を追加",
  "criteriaExtraction.addCriterionModalTitle": "評価観点を追加",
  "criteriaExtraction.criterionTitleLabel": "観点名",
  "criteriaExtraction.criterionTitlePlaceholder": "例：論理的構成、創造性、実現可能性 など",
  "criteriaExtraction.criterionDescriptionsLabel": "評価項目（任意）",
  "criteriaExtraction.criterionDescriptionPlaceholder": "この観点で評価する具体的な項目を入力",
  "criteriaExtraction.removeCriterionDescription": "評価項目を削除",
  "criteriaExtraction.addCriterionDescriptionButton": "評価項目を追加",
  "criteriaExtraction.addCriterionConfirmButton": "観点を追加",
  "criteriaExtraction.newCriterionTitle": "新しい観点",
  "criteriaExtraction.newCriterionDescription": "この観点について評価します",
  "criteriaExtraction.generation.extracting": "評価観点を抽出しています...",
  "criteriaExtraction.generation.extractingDescription": "AIが入力内容を分析して関連する評価観点を抽出しています。",
  "criteriaExtraction.successTitle": "観点抽出が完了しました！",
  "criteriaExtraction.successDescription": "各観点の内容を確認し、必要に応じて編集してから次のステップに進んでください。",
  "criteriaExtraction.nextButton": "比較評価へ",
  "criteriaExtraction.prevButton": "評価対象登録に戻る",
  "criteriaExtraction.edit.modalTitle": "観点を編集 ({{index}}/{{total}})",
  "criteriaExtraction.edit.titlePlaceholder": "観点名を入力",
  "criteriaExtraction.edit.descriptionPlaceholder": "この観点について説明してください",
  "criteriaExtraction.edit.save": "保存",
  "criteriaExtraction.edit.cancel": "キャンセル",
  "criteriaExtraction.form.titleLabel": "観点名",
  "criteriaExtraction.form.descriptionLabel": "説明文",
  "criteriaExtraction.form.addDescription": "説明を追加",

  // Product Registration
  "productRegistration.title": "まず、何を評価しますか？",
  "productRegistration.description": "レポート、プレゼン、作品など、評価したいものを登録しましょう",
  "productRegistration.quickInput.enable": "簡易入力",
  "productRegistration.securityNotice": "🔒 セキュリティモードが有効です。評価対象名は暗号化されて保存されます。",
  "productRegistration.viewToggle.form": "フォーム",
  "productRegistration.viewToggle.formTitle": "フォーム形式",
  "productRegistration.viewToggle.table": "表形式",
  "productRegistration.viewToggle.tableTitle": "表形式",
  "productRegistration.import.drive": "Google Driveからインポート",
  "productRegistration.import.driveTitle": "Google Driveからインポート",
  "productRegistration.import.driveLabel": "Google Driveからファイルをインポート",
  "productRegistration.import.csv": "CSVファイルをアップロード",
  "productRegistration.import.csvTitle": "CSVファイルをアップロード",
  "productRegistration.import.csvLabel": "CSVファイルから評価対象をアップロード",
  "productRegistration.import.template": "CSVテンプレートをダウンロード",
  "productRegistration.import.templateTitle": "CSVテンプレートをダウンロード",
  "productRegistration.import.templateLabel": "CSVテンプレートファイルをダウンロード",
  "productRegistration.import.driveDetail": "Google Driveからインポート: {{fileName}}",
  "productRegistration.form.titleLabel": "評価対象名",
  "productRegistration.form.titlePlaceholder": "例：レポートA、企画案B、プロジェクトC など",
  "productRegistration.form.titleHelp": "評価する対象の名前を入力してください",
  "productRegistration.form.linkLabel": "リンク（任意）",
  "productRegistration.form.linkPlaceholder": "https://drive.google.com/... など",
  "productRegistration.form.linkHelp": "関連資料やファイルのURLがあれば入力してください",
  "productRegistration.form.detailLabel": "詳細・コメント",
  "productRegistration.form.detailPlaceholder": "評価対象の特徴、内容、背景情報など、評価に必要な詳細を記入してください。\n例：「卒業論文のドラフト版、経済学部3年生が作成した地域活性化に関する提案書」",
  "productRegistration.form.detailHelp": "評価者が適切に評価できるよう、対象の内容や特徴を具体的に記入してください",
  "productRegistration.form.addButton": "ここをクリックして追加",
  "productRegistration.form.modalTitle": "評価対象を追加",
  "productRegistration.emptyHint": "",
  "productRegistration.list.title": "登録済み評価対象（{{count}}件）",
  "productRegistration.list.encryptedBadge": "🔒 暗号化済み",
  "productRegistration.list.encrypted": "暗号化されています",
  "productRegistration.edit.titlePlaceholder": "評価対象名を入力",
  "productRegistration.edit.linkPlaceholder": "リンクURLを入力",
  "productRegistration.edit.detailPlaceholder": "詳細・コメントを入力",
  "productRegistration.edit.save": "保存",
  "productRegistration.edit.cancel": "キャンセル",
  "productRegistration.edit.modalTitle": "評価対象を編集 ({{index}}/{{total}})",
  "productRegistration.preview": "{{title}}をプレビュー",
  "productRegistration.edit": "{{title}}を編集",
  "productRegistration.delete": "{{title}}を削除",
  "productRegistration.googleDrive.importedDetail": "Google Driveからインポート: {{name}}",
  "productRegistration.csv.header1": "評価対象名",
  "productRegistration.csv.detail1": "詳細説明",
  "productRegistration.csv.validationError": "CSVファイルにreviewTitleとreviewCommentの列が必要です。テンプレートをダウンロードして確認してください。",
  "productRegistration.error.encryptionFailed": "評価対象名の暗号化に失敗しました。セキュリティ設定を確認してください。",
  "productRegistration.navigation.next": "観点抽出へ",
  "productRegistration.mode.detailed": "詳細入力モード",
  "productRegistration.mode.quick": "クイック入力モード",
  "productRegistration.quickInput.placeholder": "評価対象名を入力してEnterキー（URLは後で追加可能）",
  "productRegistration.quickInput.hint": "Enterキーで追加 • 5個ごとに詳細入力画面が表示されます",
  "productRegistration.quickInput.collectDetails": "詳細を入力する",
  "productRegistration.list.noDetail": "詳細未入力（クリックして編集）",
  "productRegistration.detailsDialog.title": "評価対象の詳細を入力",
  "productRegistration.detailsDialog.progress": "{{current}} / {{total}}",
  "productRegistration.detailsDialog.productTitle": "「{{title}}」の詳細",
  "productRegistration.detailsDialog.detailLabel": "詳細・コメント",
  "productRegistration.detailsDialog.detailPlaceholder": "この評価対象の特徴、評価のポイント、感想など",
  "productRegistration.detailsDialog.linkLabel": "参考URL（任意）",
  "productRegistration.detailsDialog.linkPlaceholder": "https://example.com",
  "productRegistration.detailsDialog.hint": "詳細な情報があると、より精度の高い評価が可能になります",
  "productRegistration.detailsDialog.skip": "スキップ",
  "productRegistration.detailsDialog.skipAndComplete": "スキップして完了",
  "productRegistration.detailsDialog.next": "次へ",
  "productRegistration.detailsDialog.complete": "完了",
  "productRegistration.registeredItems": "登録済み評価対象（{{count}}件）",
  "productRegistration.encryptedBadge": "🔒 暗号化済み",
  "productRegistration.encryptedTitle": "暗号化されています",
  "productRegistration.previewTitle": "{{title}}をプレビュー",
  "productRegistration.editTitle": "{{title}}を編集",
  "productRegistration.deleteTitle": "{{title}}を削除",
  "productRegistration.directRubric.title": "ルーブリックを直接作成",
  "productRegistration.directRubric.description": "観点抽出をスキップして、ルーブリックを手動で作成することもできます。",
  "productRegistration.directRubric.button": "ルーブリック手動作成へ",
  "productRegistration.nextButton": "観点抽出へ",
  "productRegistration.error.decryptionLog": "評価対象 {{index}} の復号化エラー:",
  "productRegistration.error.decryptionDisplay": "[復号化エラー]",
  "productRegistration.error.encryptionLog": "評価対象名の暗号化エラー:",
  "productRegistration.error.encryptionAlert": "評価対象名の暗号化に失敗しました。セキュリティ設定を確認してください。",
  "productRegistration.error.csvAlert": "CSVファイルにreviewTitleとreviewCommentの列が必要です。テンプレートをダウンロードして確認してください。",
  "productRegistration.csv.exampleTitle1": "評価対象名1",
  "productRegistration.csv.exampleDetail1": "詳細説明1",
  "productRegistration.csv.exampleTitle2": "評価対象名2",
  "productRegistration.csv.exampleDetail2": "詳細説明2",

  // Preview Modal
  "preview.title": "{{title}} - プレビュー",
  "preview.loading": "読み込み中...",
  "preview.loadError": "読み込みエラー",
  "preview.loadErrorDetail": "ページの読み込みに失敗しました",
  "preview.invalidUrl": "無効なURL",
  "preview.invalidUrlDetail": "有効なURLではありません",
  "preview.pageLoadError": "ページを読み込めませんでした",
  "preview.comment": "コメント",
  "preview.commentPlaceholder": "この評価対象に関するコメントを入力...",
  "productRegistration.csv.exampleTitle3": "評価対象名3",
  "productRegistration.csv.exampleDetail3": "詳細説明3",

  // Comparison Evaluation
  "comparisonEvaluation.emptyState.title": "評価対象と観点を先に設定してください",
  "comparisonEvaluation.emptyState.description": "比較評価を行うには、評価対象と観点の両方が必要です。",
  "comparisonEvaluation.emptyState.backToProducts": "評価対象登録に戻る",
  "comparisonEvaluation.emptyState.backToCriteria": "観点抽出に戻る",
  "comparisonEvaluation.title": "いくつか、良い順にならべてみましょう",
  "comparisonEvaluation.description": "",
  "comparisonEvaluation.criterionSelector.title": "評価観点を選択",
  "comparisonEvaluation.productsPanel.title": "評価対象",
  "comparisonEvaluation.productsPanel.hint": "ドラッグして数直線上に配置してください",
  "comparisonEvaluation.evaluationLine.low": "低い",
  "comparisonEvaluation.evaluationLine.high": "高い",
  "comparisonEvaluation.evaluationLine.hint": "配置済みのアイテムもドラッグして再配置できます",
  "comparisonEvaluation.progress.prefix": "進捗: ",
  "comparisonEvaluation.progress.suffix": " {{placed}} / {{total}} 件配置済み",
  "comparisonEvaluation.progress.completed": "すべての評価が完了しました",
  "comparisonEvaluation.options.title": "配置方法を選択",
  "comparisonEvaluation.options.description": "全ての項目を一度に配置するか、ルーブリック作成後にクイックモードで配置するかを選択できます。",
  "comparisonEvaluation.options.quickModeButton": "クイック評価モードを使用",
  "comparisonEvaluation.options.quickModeNote": "※ ルーブリック作成後に1つずつ配置する簡単モード",
  "comparisonEvaluation.nextButton": "等級設定へ",
  "comparisonEvaluation.prevButton": "観点抽出に戻る",

  // Grade Assignment
  "gradeAssignment.emptyState.title": "評価を完了してください",
  "gradeAssignment.emptyState.description": "等級設定を行うには、比較評価が完了している必要があります。",
  "gradeAssignment.emptyState.backButton": "比較評価に戻る",
  "gradeAssignment.title": "等級設定",
  "gradeAssignment.description": "各観点について、等級の境界線をドラッグして調整してください。",
  "gradeAssignment.criterionSelector.title": "観点を選択",
  "gradeAssignment.gradeSuffix": "等級",
  "gradeAssignment.gradeSettings.titleSuffix": "の等級設定",
  "gradeAssignment.editGradesButton": "等級を編集",
  "gradeAssignment.boundaries.title": "等級境界の調整",
  "gradeAssignment.boundaries.description": "境界線をドラッグして等級の範囲を調整してください",
  "gradeAssignment.distribution.title": "等級分布",
  "gradeAssignment.table.grade": "等級",
  "gradeAssignment.table.count": "人数",
  "gradeAssignment.table.percentage": "割合",
  "gradeAssignment.table.subjects": "評価対象",
  "gradeAssignment.table.tooltip": "ダブルクリックで詳細を表示",
  "gradeAssignment.nextButton": "ルーブリック生成へ",
  "gradeAssignment.prevButton": "比較評価に戻る",
  "gradeAssignment.modal.title": "等級の編集",
  "gradeAssignment.modal.gradeNamesTitle": "等級名の設定",
  "gradeAssignment.modal.gradeLabel": "等級{{number}}",
  "gradeAssignment.modal.deleteButton": "削除",
  "gradeAssignment.modal.addGradeButton": "等級を追加",
  "gradeAssignment.modal.doneButton": "完了",
  "gradeAssignment.modal.gradePlaceholder": "等級名を入力してください",
  "gradeAssignment.status.notEvaluated": "未評価",
  "gradeAssignment.status.notSet": "未設定",
  "gradeAssignment.saveSuccess": "評価データが保存されました！",
  "gradeAssignment.boundaryLabel": "{{upper}}・{{lower}}境界",
  "gradeAssignment.doubleClickToView": "ダブルクリックで詳細を表示",
  "gradeAssignment.dragOrDoubleClick": "ドラッグで位置変更、ダブルクリックで詳細表示",
  "gradeAssignment.dragBoundaryHint": "境界線をドラッグして等級の範囲を調整できます",
  "gradeAssignment.percentAbove": "{{percent}}%以上が{{grade}}",
  "gradeAssignment.gradeNumber": "Grade{{number}}",
  "gradeAssignment.grade": "等級",
  "rubricGeneration.emptyState.title": "等級設定を完了してください",
  "rubricGeneration.emptyState.description": "ルーブリック生成を行うには、等級設定が完了している必要があります。",
  "rubricGeneration.emptyState.backButton": "等級設定に戻る",
  "rubricGeneration.title": "ルーブリック生成",
  "rubricGeneration.description": "上位2作品の差異を分析して、詳細なルーブリックを作成します。",
  "rubricGeneration.progress.title": "等級境界差異分析の進捗",
  "rubricGeneration.progress.criteriaComplete": "観点完了",
  "rubricGeneration.progress.boundaryComplete": "境界完了",
  "rubricGeneration.criterionSelector.title": "観点を選択",
  "rubricGeneration.question.criterionLabel": "観点:",
  "rubricGeneration.question.gradeSuffix": "等級",
  "rubricGeneration.question.moreCount": "他{{count}}件",
  "rubricGeneration.question.title": "「{{criterion}}」という観点において、{{upperGrade}}等級と{{lowerGrade}}等級の作品にはどのような差があると思いましたか？",
  "rubricGeneration.question.placeholder": "例：{{upperGrade}}等級の作品は論理構成が明確で、根拠となるデータが豊富に示されている。一方、{{lowerGrade}}等級の作品は論点は良いが、具体例が少なく説得力に欠ける部分がある。",
  "rubricGeneration.question.addButton": "差異を追加",
  "rubricGeneration.question.recordedDifferences": "記録された差異:",
  "rubricGeneration.question.deleteButton": "削除",
  "rubricGeneration.question.completeButton": "この境界の分析を完了",
  "rubricGeneration.summary.title": "等級境界分析結果サマリー",
  "rubricGeneration.summary.allAnalysisComplete": "すべての観点の分析が完了しました",
  "rubricGeneration.summary.boundaryTitle": "{{upperGrade}}・{{lowerGrade}}境界",
  "rubricGeneration.summary.differencesCount": "{{count}}個の差異を記録",
  "rubricGeneration.generation.generating": "ルーブリックを生成中...",
  "rubricGeneration.generation.generatingDescription": "評価データから最適なルーブリックを作成しています",
  "rubricGeneration.generation.generateButton": "AIルーブリックを生成",
  "rubricGeneration.display.title": "生成されたルーブリック",
  "rubricGeneration.display.description": "AIが分析した差異情報から作成された詳細なルーブリックです。",
  "rubricGeneration.display.regenerateButton": "再生成",
  "rubricGeneration.display.doubleClickToEdit": "ダブルクリックで編集",
  "rubricGeneration.display.editHint": "セルをダブルクリックすると内容を編集できます",
  "rubricGeneration.initial.title": "ルーブリック作成方法を選択",
  "rubricGeneration.initial.description": "差異分析を行ってから生成するか、すぐに自動生成するかを選べます",
  "rubricGeneration.initial.manualAnalysis": "差異分析を行う",
  "rubricGeneration.initial.manualDescription": "等級間の差異を詳しく分析してから、より精度の高いルーブリックを生成します",
  "rubricGeneration.initial.startAnalysis": "分析を開始",
  "rubricGeneration.initial.autoGenerate": "自動生成",
  "rubricGeneration.initial.autoDescription": "AIが評価データから自動的にルーブリックを生成します。生成後に編集可能です",
  "rubricGeneration.initial.generateNow": "今すぐ生成",
  "rubricGeneration.navigation.nextToQuick": "クイック評価へ",
  "rubricGeneration.navigation.backToGrade": "等級設定に戻る",
  "rubricGeneration.generation.step1": "評価データを分析中",
  "rubricGeneration.generation.step2": "AIがルーブリックを生成中",
  "rubricGeneration.generation.step3": "最終調整を実施中",
  "rubricGeneration.differenceDialog.title": "等級差の説明",
  "rubricGeneration.differenceDialog.progress": "質問 {{current}} / {{total}}",
  "rubricGeneration.differenceDialog.question": "「{{criterion}}」の観点で、なぜ「{{productA}}」は{{gradeA}}等級で「{{productB}}」は{{gradeB}}等級なのか、その差を教えてください",
  "rubricGeneration.differenceDialog.hint": "具体的な違いを説明することで、より精度の高いルーブリックが生成されます",
  "rubricGeneration.differenceDialog.placeholder": "例：{{gradeA}}の作品は論理構成が明確で根拠が豊富に示されているのに対し、{{gradeB}}の作品は論点は良いが具体例が少なく説得力に欠ける部分がある",
  "rubricGeneration.differenceDialog.skip": "スキップ",
  "rubricGeneration.differenceDialog.skipAndGenerate": "スキップして生成",
  "rubricGeneration.differenceDialog.next": "次へ",
  "rubricGeneration.differenceDialog.completeAndGenerate": "完了して生成",
  "rubricGeneration.error.generation": "ルーブリック生成中にエラーが発生しました",

  // Progress Bar
  "progressBar.label": "評価の進捗",
  "progressBar.messages.criteriaSetup": "観点を設定すると15%完了します",
  "progressBar.messages.completed": "🎉 評価が完了しました！",
  "progressBar.messages.progress": "評価対象: {{products}}件 × 観点: {{criteria}}件 = {{total}}評価",
  "progressBar.show": "進捗を表示",
  "progressBar.hide": "進捗を非表示",

  // Evaluation Header
  "evaluationHeader.placeholder": "評価タイトルを入力してください",
  "evaluationHeader.saveTitle": "保存",
  "evaluationHeader.cancelTitle": "キャンセル",
  "evaluationHeader.untitled": "無題の評価",
  "evaluationHeader.editTitle": "タイトルを編集",

  // Draggable Product Card
  "draggableProductCard.detailsCount": "詳細: {{count}} 文字",
  "draggableProductCard.previewAvailable": "🔗 プレビュー可能",
  "draggableProductCard.showPreview": "プレビューを表示",
  "draggableProductCard.editDetails": "詳細を編集",
  "draggableProductCard.position": "位置: {{value}}",
  "draggableProductCard.rank": "順位: {{value}}",
  "draggableProductCard.placed": "配置済み",

  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.title": "クイック評価モード",
  "comparativeEvaluationQuick.criterionSelector.title": "評価観点を選択",
  "comparativeEvaluationQuick.productsPanel.title": "評価対象",
  "comparativeEvaluationQuick.productsPanel.currentlyEvaluating": "現在評価中:",
  "comparativeEvaluationQuick.nextButton": "次へ",
  "comparativeEvaluationQuick.prevButton": "戻る",
  "comparativeEvaluationQuick.grades.excellent": "優秀",
  "comparativeEvaluationQuick.grades.good": "良好",
  "comparativeEvaluationQuick.grades.average": "普通",
  "comparativeEvaluationQuick.grades.needsImprovement": "要改善",
  "comparativeEvaluationQuick.completion.title": "評価完了",
  "comparativeEvaluationQuick.completion.subtitle": "{{count}}件すべての評価が完了しました",
  "comparativeEvaluationQuick.completion.evaluationCount": "評価件数",
  "comparativeEvaluationQuick.completion.criteriaCount": "評価観点",
  "comparativeEvaluationQuick.completion.viewResults": "結果を確認",
  "comparativeEvaluationQuick.completion.detailAdjustment": "詳細調整",
  "comparativeEvaluationQuick.criterionComplete.title": "「{{criterion}}」完了",
  "comparativeEvaluationQuick.criterionComplete.subtitle": "{{count}}件の評価が完了しました",
  "comparativeEvaluationQuick.criterionComplete.nextCriterion": "次の観点: ",
  "comparativeEvaluationQuick.criterionComplete.proceedToNext": "次の観点に進む",
  "comparativeEvaluationQuick.criterionComplete.allComplete": "すべての観点の評価が完了しました",
  "comparativeEvaluationQuick.criterionComplete.viewResults": "結果を確認",
  "comparativeEvaluationQuick.empty.title": "評価するデータがありません",
  "comparativeEvaluationQuick.empty.description": "製品と評価基準を設定してください。",
  "comparativeEvaluationQuick.header.doubleClickToView": "ダブルクリックで詳細を表示",
  "comparativeEvaluationQuick.header.progress": "{{completed}} / {{total}} 完了",
  "comparativeEvaluationQuick.header.criterionProgress": "({{current}} / {{total}} 観点)",
  "comparativeEvaluationQuick.navigation.nextCriterion": "次の観点: {{name}}",
  "comparativeEvaluationQuick.progress.remaining": "残り {{count}} 件",
  "comparativeEvaluationQuick.gradeExplanation.instruction": "左端（D：要改善）から右端（A：優秀）まで、評価したい位置をクリックしてください。",
  "comparativeEvaluationQuick.gradeExplanation.currentPosition": " 現在の位置：{{grade}}（{{description}}）",
  "comparativeEvaluationQuick.actions.switchToAllMode": "全配置モードに切り替え",
  "comparativeEvaluationQuick.shortcuts.enterNext": "Enterキーで次の観点に進む",
  "comparativeEvaluationQuick.shortcuts.spaceSkip": "スペースキーで次の観点をスキップ",
  "comparativeEvaluationQuick.criterion.instruction": "この観点での優劣を判断してください",
  "comparativeEvaluationQuick.cursor.nextCriterion": "次の観点に進んでください",
  "comparativeEvaluationQuick.cursor.nextStep": "次のステップに進んでください",

  "csvExport.export": "CSVエクスポート",
  
  // Evaluation Page
  "evaluation.noDataToSave": "保存するデータがありません",
  "evaluation.dataSaved": "データが正常に保存されました！",
  "evaluation.saveFailed": "保存に失敗しました",
  "evaluation.saveError": "保存中にエラーが発生しました",
  "evaluation.failedKeyword": "失敗",
  "evaluation.errorKeyword": "エラー",
  "evaluation.saving": "💾 保存中...",
  
  // Missing translations
  "evaluation.loadError": "プロジェクトの読み込みに失敗しました",
  "evaluation.loadingProject": "プロジェクトを読み込み中...",
  "evaluation.dataRetained": " - データは保持されています",
  "evaluation.errorOccurred": "エラーが発生しました: ",
  
  // Step guidance messages
  "evaluation.guidance.registerProducts": " 評価対象となる製品を登録してください",
  "evaluation.guidance.completeRegistration": " 製品登録を完了して「次へ」をクリック",
  "evaluation.guidance.extractCriteria": " 評価観点を抽出または手動で追加してください",
  "evaluation.guidance.confirmCriteria": " 観点の確認・編集を行い「次へ」をクリック",
  "evaluation.guidance.placeProducts": "💡 各観点で少なくとも{{count}}個の製品を配置してください",
  "evaluation.guidance.placeMoreProducts": "💡 「{{criterionTitle}}」の観点であと{{remaining}}個の製品を配置してください",
  "evaluation.guidance.comparisonComplete": " 必要な比較が完了しました。「次へ」をクリックして等級設定へ",
  "evaluation.guidance.setGrades": "💡 「{{criterionTitle}}」の等級（A,B,C等）を設定してください",
  "evaluation.guidance.gradesComplete": " 等級設定が完了しました。「次へ」をクリックしてルーブリック生成へ",
  "evaluation.guidance.rubricGenerated": " ルーブリックが生成されました。「次へ」をクリックして次のステップへ",
  "evaluation.guidance.generateRubric": " ルーブリックを生成してください",
  "evaluation.guidance.startEvaluation": "💡 評価を始めましょう！クリックするだけで簡単に配置できます",
  "evaluation.guidance.progress25": "💡 順調です！もうすぐ半分まで来ますよ（{{progress}}%完了）",
  "evaluation.guidance.progress50": "💡 半分を超えました！この調子です（{{progress}}%完了）",
  "evaluation.guidance.progress75": "💡 75%まで来ました！ゴールが見えてきました",
  "evaluation.guidance.almostDone": "💡 あと少し！残り{{unplacedCount}}個で完成です",
  "evaluation.guidance.allComplete": " すべての評価が完了しました。「次へ」をクリックして成績表出力へ",
  "evaluation.guidance.downloadReport": " 成績表をダウンロードまたは共有してください",
  
  // Progress reminder messages
  "evaluation.reminder.continuePlacing": "💭 「{{criterionTitle}}」の観点で製品の配置を続けてください（あと{{remaining}}個）",
  "evaluation.reminder.almostHalf": "💭 「{{criterionTitle}}」の評価を続けてみましょう。もうすぐ半分です！",
  "evaluation.reminder.overHalf": "💭 「{{criterionTitle}}」の評価、半分を超えました！",
  "evaluation.reminder.fewLeft": "💭 「{{criterionTitle}}」の評価、あと{{remaining}}個！",
  "evaluation.currentDataRetained": " - 現在のデータは保持されています",
  "evaluation.unknownError": "不明なエラー",
  
  // Security mode
  "security.modeEnabled": "セキュリティモード有効",
  
  // Footer
  "footer.privacyPolicy": "プライバシーポリシー",
  "footer.termsOfService": "利用規約",
  
  // Invitation page
  "invitation.invalid": "招待が無効です",
  "invitation.accepted": "招待を受け入れました",
  "invitation.failed": "招待の処理に失敗しました",
  "invitation.invalidOrExpired": "招待が無効または期限切れです",
  "invitation.invalidTitle": "無効な招待",
  "invitation.invalidDescription": "この招待リンクは無効です。",
  "invitation.backToDashboard": "ダッシュボードに戻る",
  "invitation.acceptedTitle": "招待を受け入れました",
  "invitation.acceptedDescription": "コラボレーションへの参加が完了しました。",
  "invitation.redirecting": "ダッシュボードにリダイレクト中...",
  "invitation.goToDashboard": "ダッシュボードへ",
  "invitation.title": "コラボレーションへの招待",
  "invitation.description": "プロジェクトへのコラボレーション招待を受け取りました。",
  "invitation.acceptQuestion": "この招待を受け入れますか？",
  "invitation.processing": "処理中...",
  "invitation.accept": "招待を受ける",
  "invitation.decline": "辞退する",
  "invitation.capabilitiesTitle": "コラボレーターとしての権限",
  "invitation.capability1": "プロジェクトの閲覧と編集",
  "invitation.capability2": "評価の実施と修正",
  "invitation.capability3": "レポートの生成とエクスポート",
  "invitation.capability4": "他のメンバーの招待",
  "invitation.capability5": "プロジェクト設定の変更",
  
  // Auto save
  "autoSave.15seconds": "15秒",
  "autoSave.30seconds": "30秒",
  "autoSave.1minute": "1分",
  "autoSave.2minutes": "2分",
  "autoSave.5minutes": "5分",
  "autoSave.settings": "自動保存設定",
  "autoSave.enable": "自動保存を有効にする",
  "autoSave.interval": "保存間隔",
  "autoSave.currentSetting": "現在の設定:",
  "autoSave.saveNow": "今すぐ保存",
  "autoSave.saved": "保存済み",
  "autoSave.descriptionShort": "データは自動的に保存されます",
  "autoSave.descriptionLocal": "ローカルストレージにも保存されます",
  "autoSave.descriptionError": "エラー時はデータが保持されます",
  
  // Weight configuration
  "weight.title": "重み付け設定",
  "weight.description": "各観点の重要度を設定できます。合計が100%になるように調整してください。",
  "weight.equalDistribution": "均等配分",
  "weight.currentTotal": "現在の合計:",
  "weight.criterion": "観点",
  "weight.weight": "重み",
  "weight.maxScore": "最高スコア",
  "weight.saveSettings": "設定を保存",
  
  // CSV Export
  "csvExport.templateRequired": "テンプレートを入力してください",
  "csvExport.exportFailed": "エクスポートに失敗しました",
  "csvExport.sampleComment": "これはサンプルコメントです",
  "csvExport.currentUser": "現在のユーザー",
  "csvExport.title": "CSVエクスポート",
  "csvExport.exportStatus": "エクスポート状況",
  "csvExport.remaining": "残り回数:",
  "csvExport.unlimited": "無制限",
  "csvExport.templateLabel": "エクスポートテンプレート",
  "csvExport.templatePlaceholder": "テンプレートを入力してください...",
  "csvExport.templateHelp": "利用可能な変数を使用してテンプレートを作成してください",
  "csvExport.availablePlaceholders": "利用可能な変数",
  "csvExport.preview": "プレビュー",
  "csvExport.filename": "ファイル名",
  "csvExport.format": "形式",
  "csvExport.includeHeader": "ヘッダーを含める",
  "csvExport.exporting": "エクスポート中...",
  
  // Product registration
  "productRegistration.error.encryptionError": "暗号化エラーが発生しました",
  "productRegistration.quickInput.disable": "詳細入力モードに切り替える",
  "gradeAssignment.distribution.doubleClickToView": "ダブルクリックして詳細を表示",
  "criteriaExtraction.removeDescription": "説明を削除",
  "criteriaExtraction.editCriterion": "観点を編集",
  "criteriaExtraction.deleteCriterion": "観点を削除",
  "report.backToRubric": "ルーブリックに戻る",
  "preview.openInNewTab": "新しいタブで開く",
  "report.generateComment": "コメントを生成",
  "report.backToQuick": "クイック評価に戻る",
  "productRegistration.noDetailProvided": "詳細が提供されていません",
  "rubricGeneration.display.editCellAria": "セルを編集",
  
  // Product Registration Import
  "productRegistration.import.sectionTitle": "インポート",
  "productRegistration.import.googleDrive": "Google ドライブ",
  "productRegistration.import.localTitle": "ローカルファイルからインポート",
  "productRegistration.import.localLabel": "ローカルファイルからインポート",
  "productRegistration.import.local": "ローカルファイル",
  
  // Final missing translations
  "productRegistration.import.csvShort": "CSV",
  "productRegistration.export.sectionTitle": "エクスポート",
  "productRegistration.export.template": "テンプレート",
  "localFolderBrowser.loading": "読み込み中...",
  "localFolderBrowser.loadingWithFile": "{{file}} を読み込み中...",
  "localFolderBrowser.title": "ローカルファイルを選択",
  "localFolderBrowser.searchPlaceholder": "ファイルを検索...",
  "localFolderBrowser.selectAll": "すべて選択",
  "localFolderBrowser.clearSelection": "選択を解除",
  "localFolderBrowser.selectedCount": "{{count}}個選択中",
  "localFolderBrowser.noFilesFound": "ファイルが見つかりません",
  "localFolderBrowser.dropzone.text": "ファイルをドラッグ＆ドロップまたはクリックして選択",
  "localFolderBrowser.dropzone.acceptedFormats": "対応形式: .txt, .csv, .docx, .pdf, .xlsx",
  "localFolderBrowser.cancel": "キャンセル",
  "localFolderBrowser.import": "インポート",
  "localFolderBrowser.selectFolder": "フォルダを選択",
  "localFolderBrowser.dropMessage": "フォルダをドラッグ&ドロップ",
  "localFolderBrowser.dropMessageOr": "または「フォルダを選択」をクリック",
  "localFolderBrowser.filesTotal": "合計: {{count}} ファイル",
  "localFolderBrowser.filesSelected": "選択: {{count}} ファイル",
  "localFolderBrowser.select": "選択 ({{count}})",
  "localFolderBrowser.preview": "プレビュー",
  
  // Error messages
  "error.encryptionError": "暗号化エラー",
  "error.csvParseError": "CSVファイルの解析に失敗しました",
  "error.googleDriveImportError": "Google Driveからのインポートに失敗しました",
  "error.localFileProcessError": "ファイルの処理中にエラーが発生しました",
  "error.fileLoadError": "ファイルの読み込みに失敗しました"
};